export default __webpack_public_path__ + "static/media/remy_logo.d27118d6.jpg";